module.exports = function() {

    require('../../../../node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js');
    require('../../../../node_modules/eonasdan-bootstrap-datetimepicker/build/js/bootstrap-datetimepicker.min.js');

    showDatePicker();
    showTimePicker();
    showDateTimePicker()

    function showDatePicker(){
        var $datePicker = $('.js-datepicker');

        $datePicker.datepicker({
            autoclose: true,
            format: "dd/mm/yyyy"
        });
    }

    function showTimePicker(){
        var $timePicker = $('.js-timepicker');

        $timePicker.datetimepicker({
            format: 'HH:mm'
       /**     format: 'LT'*/
        });
    }

    function showDateTimePicker(){
        var $datetimePicker = $('.js-datetimepicker');

        $datetimePicker.datetimepicker({
            format: 'YYYY-MM-DD HH:mm'
            /**     format: 'LT'*/
        });
    }

}();
